import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';
import { validationMobileScreenshareDataSchema } from 'features/sdk/utils/schemas';
import { fromZodError } from 'zod-validation-error';
import { RTCClient } from 'utils/webrtc';
import type { MobileScreenshareData } from 'utils/eventBus';

export function* onStopMobileScreenshareCommandSaga(data: MobileScreenshareData) {
  const validationData = validationMobileScreenshareDataSchema.safeParse(data);

  if (!validationData.success) {
    const validationError = fromZodError(validationData.error);

    yield call(eventBus.error, {
      name: 'mobile-screenshare',
      message: validationError.toString(),
    });
  }

  yield call(RTCClient.screensharingFeed.stopMobileScreenshare, data);
}
